import React, {
  Component
} from 'react';
import {
  Link
} from 'react-router';
import {
  connect
} from 'react-redux';
import {
  bindActionCreators
} from 'redux';
import {
  changeColor,
  clearDraw
} from '../../actions/ts_overlay_actions.js';
import {updateModal} from '../../actions/modal.js';
import {updateCanvas} from '../../actions/ts_canvas_actions.js';
import {undoCanvas} from '../../containers/landing/drawable.js';
import ReactDOM from 'react-dom';
var Undo = React.createClass({

  undo(canvas){
     if (canvas.history && canvas.history.length > 0)
     {
   var {dispatch,canvas} = this.props;
   var canvasHistory = canvas.history;
   var c = canvas.canvas;
   var ctx = canvas.context;
   canvasHistory.pop();
   dispatch(updateCanvas(c,ctx,canvasHistory));
    }
  },

  render() {
    var {overlay,map,currentUser,canvas} = this.props;
    var undoColor = 'fa fa-undo fa-fw icon-gray';
    if (canvas.history && canvas.history.length > 0)
    {
     undoColor = 'fa fa-undo fa-fw';
      }
    return (
      <Link onClick={(event) => {
          this.undo(canvas);
        }} className="navbar-brand">
          <span>
            <i className={undoColor}></i>
          </span>
        </Link>
    );
  }
});

module.exports = connect((state) => {
  return {
    overlay: state.overlay, map: state.map, currentUser: state.currentUser, canvas: state.canvas
  }
})(Undo);



// WEBPACK FOOTER //
// ./src/app/components/tools/undo.js